<template>
  <v-row>
    <v-col cols="12" class="d-flex align-center">
      <h2>{{ $t('video.head') }}</h2>
      <v-divider class="mx-3" vertical />
      <v-breadcrumbs :items="breadcrumbsItems" divider=">>" />
    </v-col>
    <v-divider class="mx-3" vertical />
    <v-col cols="12">
      <v-card>
        <v-card-title> {{ $t('video.head_list2') }} </v-card-title>
        <v-divider class="mx-3" />
        <v-card-actions>
          <v-row>
            <v-col cols="12" xs="12" md="6" lg="4">
              <v-text-field v-model="form.title" :label="$t('video.header_input1')" outlined dense />
            </v-col>
            <v-col cols="12" xs="12" md="8" lg="8">
              <v-text-field v-model="form.detail" :label="$t('video.header_input2')" outlined dense />
            </v-col>
            <v-col cols="12" xs="12" md="6" lg="4">
              <v-select v-model="form.enable" :label="$t('video.header_input4')" :items="statusItems" value="value"
                outlined dense />
            </v-col>
            <v-col cols="6" xs="12">
              <v-text-field v-model="form.image" :label="$t('video.header_input3')" outlined dense />
            </v-col>
          </v-row>
        </v-card-actions>
        <v-divider class="mx-3" />
        <v-card-actions>
          <v-spacer />
          <v-btn color="warning" @click="$router.push({ name: 'video' })">
            <v-icon>mdi-arrow-left</v-icon>
            <span class="px-3">{{ $t('back') }}</span>
          </v-btn>
          <v-btn color="success" @click="save" class="px-3" :loading="loading">
            <v-icon>mdi-content-save</v-icon>
            <span class="px-3">{{ $t('save') }}</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import axios from 'axios'
import { onMounted } from '@vue/composition-api'
import store from '@/store'
export default {
  data() {
    return {
      breadcrumbsItems: [
        {
          text: this.$t('video.head'),
          disabled: false,
          href: '/video',
        },
        {
          text: this.$t('video.edit'),
          disabled: true,
          href: '',
        },
      ],
      statusItems: [
        {
          text: this.$t('open'),
          value: 1,
        },
        {
          text: this.$t('close'),
          value: 0,
        },
      ],
      form: {
        title: '',
        detail: '',
        url: null,
      },
      loading: false,
    }
  },
  async mounted() {
    const result = await this.$store.dispatch('getVideoList', `page=1&row=1000000`)

    const findData = result.data.filter(data => data.id == this.$route.params.id)
    if (findData.length > 0) {
      this.form = findData[0]
    } else {
      this.$router.push('/error-404')
    }
  },
  async created() {
    this.addLogPage()
  },
  methods: {
    async addLogPage() {
      try {
        let data
        const userSystem = store.getters.getuserInfo
        await axios.get('https://api.ipify.org?format=json').then(res =>
          data = {
            ip: res.data.ip,
            name: 'วิดีโอ',
            url: window.location.href,
            detail: 'แก้ไขวิดีโอ',
            admin: userSystem.name ? userSystem.name : '' ? userSystem.name : '',
          }
        )
        await this.$store.dispatch('addLogPage', data)
      } catch (e) {
        // if (!e.message.includes('Unexpected token') || !e?.includes('Unexpected token') || !e.message.includes('Unexpected identifier')) {
        //   this.$swal.fire({
        //     icon: 'error',
        //     title: e.message,
        //   })
        // }
      }
    },
    async save() {
      this.loading = true

      const template = {
        id: parseInt(this.$route.params.id),
        title: this.form.title,
        detail: this.form.detail,
        url: this.form.url,
        enable: this.form.enable === 1 ? true : false,
      }
      try {
        await this.$store.dispatch('updateVideo', template)
        this.$swal.fire(this.$t('video.alert_complete'), '', 'success')
        this.$router.push({ name: 'video' })
      } catch (e) {
        if (!e.message.includes('Unexpected token') || !e?.includes('Unexpected token') || !e.message.includes('Unexpected identifier')) {
          this.$swal.fire({
            icon: 'error',
            title: e,
          })
        }
      }
      this.loading = false
    },
  },
}
</script>
